package com.wintermar.inspection.feature.presentation.template.widget.preview

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateQuestionModel
import com.wintermar.inspection.feature.util.answer_type.toVariant
import org.jetbrains.compose.resources.painterResource

@Composable
fun QuestionRow(
    question: InspectionTemplateQuestionModel,
    modifier: Modifier = Modifier,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color,
) {
    val variant = question.answerType.toVariant()
    Column(
        modifier = modifier
            .fillMaxWidth()
            .background(color.surface.neutral.subtle.default)
            .padding(horizontal = dimension.spacing.space2)
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
                .background(
                    color = color.surface.normal,
                    shape = RoundedCornerShape(dimension.radius.lg)
                )
                .padding(dimension.spacing.space4),
            verticalArrangement = Arrangement.spacedBy(dimension.spacing.space3)
        ) {
            TextBodySmall(text = question.questionText, bold = true)
            Row(
                modifier = Modifier.background(
                    color = color.surface.neutral.subtle.default,
                    shape = RoundedCornerShape(dimension.radius.lg)
                )
                    .border(
                        width = 1.dp,
                        color = color.border.subtle,
                        shape = RoundedCornerShape(dimension.radius.lg)
                    )
                    .padding(
                        horizontal = dimension.spacing.space3,
                        vertical = dimension.spacing.space1
                    ),

                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(dimension.spacing.space2)
            ) {
                Icon(
                    painter = painterResource(variant.icon),
                    tint = variant.iconColor,
                    modifier = Modifier.size(dimension.size.icon.xs),
                    contentDescription = question.questionText
                )
                TextBodySmall(text = variant.label)
            }
        }
        Spacer(modifier = Modifier.height(dimension.spacing.space2))
    }
}
